import {MiddlewareContext} from '@/lib/middleware'
import {App} from '@/project'
import {RootState} from '@/store'
import isNumber from '@/validate/is-number'

/**
 * Runs when the router meta.middleware is 'set-biz'
 * force to replace route to index if bizId is empty
 * @param ctx
 */
export function beforeResolve(ctx: MiddlewareContext<App, RootState>) {
  if(!ctx.store) {
    throw new Error('[set-biz] middleware should have the store')
  }

  if(!ctx.store.getters['auth/authenticated'] ||
    !ctx.store.getters['auth/hasPhone'] ||
    !ctx.store.getters['biz/hasBiz']) {
    return ctx.next()
  }

  const {to: {name, params = {}, query = {}}} = ctx
  const {bizId = ''} = params

  const targetBiz = ctx.store.state.biz.bizs.find((biz) => biz.id === bizId)
  const isInBizs = Boolean(targetBiz)
  const targetBizOtherVerified = targetBiz && targetBiz?.otherBizVerified

  if(isNumber(bizId)) {
    if(isInBizs) {
      if(!targetBizOtherVerified) {
        ctx.store.commit('biz/selectBiz', bizId)
        return ctx.next()
      }
      return ctx.next({name: 'other-biz-verified', params: {bizId}, query})
    }
    return ctx.next({name: 'wrong-access'})
  }

  const firstBizId = ctx.store.getters['biz/firstBizId']
  const firstBizOtherVerified = ctx.store.getters['biz/firstBiz']?.otherBizVerified

  if(!firstBizOtherVerified) {
    return ctx.next({name: name ?? '', params: {...params, bizId: firstBizId}, query})
  }

  return ctx.next({name: 'other-biz-verified', params: {bizId: firstBizId}, query})
}
